import { API_NAMES, initApi } from "@usas/ui-web/utils/HttpApiHelper";
import { BASIC_INITIAL_STATE } from "@usas/ui-web/utils/HttpHelper";

const getApparelTypesData = (state, setState) => {
  const api = initApi(API_NAMES.PERSON, state, setState);
  const url = `/NationalTeamApparel`;
  
  return api.executeArray ? api.executeArray(url, 'GET') : null;
};

const INITIAL_APPAREL_TYPE_STATE = {
  ...BASIC_INITIAL_STATE,
  options: [],
  areOptionsLoaded: false
}

const ApparelTypeData = {
  INITIAL_APPAREL_TYPE_STATE,
  getApparelTypesData
};

export default ApparelTypeData;